<template>
  <div>
    <div class="mask" v-show="ifMask" @click="hideToast"></div>
    <div class="mainBarMember bc1">
      <img class="logo" v-lazy-load :data-src="require('../../assets/logo.png')" alt="">
      <div class="block"></div>

      <!-- 搜索框区域 -->
      <div class="search-wrapper">
        <a-input placeholder="请输入内容" class="searchBox" allow-clear v-model:value="searchValue"
          @input="handleSearchInput" @focus="isSearchFocused = true">
          <template #prefix>
            <img @click="handleSearchInput" v-lazy-load :data-src="require('../../assets/icon11.png')" alt="">
          </template>
        </a-input>

        <!-- 搜索结果下拉框 -->
        <div class="search-results" v-if="showSearchResults">
          <div class="search-loading" v-if="searchStatus === 'loading'">
            <a-spin size="small" />
            <span>搜索中...</span>
          </div>

          <div class="search-error" v-else-if="searchStatus === 'error'">
            <span>搜索异常，请重试</span>
          </div>

          <div class="search-empty" v-else-if="searchStatus === 'empty'">
            <span>暂无搜索结果</span>
          </div>

          <div class="search-items" v-else-if="searchStatus === 'success'">
            <div v-for="(item, index) in searchResults" :key="index" class="search-item"
              @click="handleSearchItemClick(item)">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>

      <div class="block"></div>
      <div class="leftBox">
        <!-- 积分看板 -->
        <div :class="(currentPage == 'board' || currentPage == 'score' || currentPage == 'grade') ? 'nav2' : 'nav1'">
          <div class="toast" v-if="ifToast[0]" @click="a">
            <div class="content" @click="goToNav('board')">企业积分看板</div>
            <div class="content" @click="goToNav('score')">ESG评分</div>
            <div class="content" @click="goToNav('grade')">ESG评价等级</div>
          </div>
          <div @click="showToast(0)">积分看板</div>
          <img class="arrow" @click="showToast(0)" v-lazy-load :data-src="require('../../assets/arrow1-1.png')" alt=""
            v-if="currentPage == 'board' || currentPage == 'score' || currentPage == 'grade'">
          <img class="arrow" @click="showToast(0)" v-lazy-load :data-src="require('../../assets/arrow1-5.png')" alt=""
            v-if="currentPage != 'board' && currentPage != 'score' && currentPage != 'grade'">
        </div>

        <!-- 文件管理 -->
        <div
          :class="currentPage == 'file1' || currentPage == 'file2' || currentPage == 'file3' ? 'nav2 mgl' : 'nav1 mgl'">
          <div class="toast" v-if="ifToast[1]" @click="a">
            <div class="content" @click="goToNav('file1')">环境评价文件</div>
            <div class="content" @click="goToNav('file2')">社会评价文件</div>
            <div class="content" @click="goToNav('file3')">治理评价文件</div>
          </div>
          <div @click="showToast(1)">文件管理</div>
          <img class="arrow" @click="showToast(1)" v-lazy-load :data-src="require('../../assets/arrow1-1.png')" alt=""
            v-if="currentPage == 'file'">
          <img class="arrow" @click="showToast(1)" v-lazy-load :data-src="require('../../assets/arrow1-5.png')" alt=""
            v-if="currentPage != 'file'">
        </div>
        <!-- ESG评价改进 -->
        <div :class="currentPage == 'improve' ? 'nav2 mgl' : 'nav1 mgl'" @click="goToNav('improve')">ESG评价改进</div>
        <!-- 培训服务 -->
        <div :class="currentPage == 'course' || currentPage == 'customized' ? 'nav2 mgl' : 'nav1 mgl'">
          <div class="toast" v-if="ifToast[2]" @click="a">
            <div class="content" @click="goToNav('course')">ESG评价课程</div>
            <div class="content" @click="goToNav('customized')">定制化服务</div>
          </div>
          <div @click="showToast(2)">培训服务</div>
          <img class="arrow" @click="showToast(2)" v-lazy-load :data-src="require('../../assets/arrow1-1.png')" alt=""
            v-if="currentPage == 'course' || currentPage == 'customized'">
          <img class="arrow" @click="showToast(2)" v-lazy-load :data-src="require('../../assets/arrow1-5.png')" alt=""
            v-if="currentPage != 'course' && currentPage != 'customized'">
        </div>
        <!-- 报告 -->
        <div :class="currentPage == 'report' ? 'nav2 mgl' : 'nav1 mgl'" @click="goToNav('report')">报告及证书</div>
        <!-- 用户名 -->
        <div
          :class="currentPage == 'user' || currentPage == 'company' || currentPage == 'changePhone' || currentPage == 'loginout' ? 'nav2 mgl' : 'nav1 mgl'">
          <div class="toast w1" v-if="ifToast[3]" @click="a">
            <div class="content" @click="goToNav('user')">用户资料</div>
            <div class="content" @click="goToNav('company')">公司资料</div>
            <div class="content" @click="goToNav('changePhone')">换绑手机号</div>
            <div class="content" @click="goToNav('loginout')">退出登录</div>
          </div>
          <img v-lazy-load :data-src="require('../../assets/icon13.png')" @click="showToast(3)" alt="" class="icon">
          <div @click="showToast(3)">{{ name || '姓名' }}</div>
          <img v-lazy-load class="arrow" @click="showToast(3)" :data-src="require('../../assets/arrow1-1.png')" alt=""
            v-if="currentPage == 'user' || currentPage == 'company' || currentPage == 'changePhone' || currentPage == 'loginout'">
          <img class="arrow" @click="showToast(3)" v-lazy-load :data-src="require('../../assets/arrow1-5.png')" alt=""
            v-if="currentPage != 'user' && currentPage != 'company' && currentPage != 'loginout' && currentPage != 'changePhone'">
        </div>
        <!-- 切换到首页 -->
        <div class="loginBox" @click="goToNav('home')">切换到首页</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, useModel, defineEmits, computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/stores/useStores';
import { debounce } from 'lodash';
import Api from '@/utils/api'

const store = useStore()
const router = useRouter()
const emit = defineEmits(['updatePage', 'updateIdentity', 'update:currentPage']);
const props = defineProps({
  currentPage: {
    type: String,
    default: 'board',
    required: true
  },
  name: String
});
// const phone = ref(localStorage.getItem('phone') || '');

const ifToast = ref([false, false, false, false]);
const ifMask = ref(false);
const currentPage = useModel(props, 'currentPage');

// 搜索相关状态
const searchValue = ref('')
const searchStatus = ref('') // '', 'loading', 'success', 'error', 'empty'
const searchResults = ref([])
const isSearchFocused = ref(false)
// 添加AbortController用于取消之前的请求
let abortController = null

// 计算属性：是否显示搜索结果下拉框
const showSearchResults = computed(() => {
  return isSearchFocused.value && searchValue.value.trim() &&
    (searchStatus.value === 'loading' ||
      searchStatus.value === 'success' ||
      searchStatus.value === 'error' ||
      searchStatus.value === 'empty')
})

const showToast = (index) => {
  if (ifToast.value[index]) {
    ifToast.value = [false, false, false, false];
    ifMask.value = false;
  } else {
    ifToast.value = [false, false, false, false];
    ifToast.value[index] = !ifToast.value[index];
    ifMask.value = true;
  }
};

const hideToast = () => {
  ifToast.value = [false, false, false, false];
  ifMask.value = false;
};

const goToNav = (page) => {
  ifToast.value = [false, false, false, false];
  ifMask.value = false;
  currentPage.value = page;
  console.log('ifToast', ifToast.value);
  emit('updatePage', page);
  if (page == 'board') {
    router.push({
      path: 'memberhome',
      query: {
        currentIdentity: 'member'
      }
    })
  } else if (page == 'score') {
    router.push({
      path: 'esgRating',
      query: {
        currentIdentity: 'member'
      }
    })
  } else if (page == 'grade') {
    router.push({
      path: 'esgGrade',
      query: {
        currentIdentity: 'member'
      }
    })
  } else if (page == 'file1') {
    router.push({
      path: 'evaFile',
      query: {
        currentIdentity: 'member',
        pot: 1
      }
    })
  } else if (page == 'file2') {
    router.push({
      path: 'evaFile',
      query: {
        currentIdentity: 'member',
        pot: 2
      }
    })
  } else if (page == 'file3') {
    router.push({
      path: 'evaFile',
      query: {
        currentIdentity: 'member',
        pot: 3
      }
    })
  } else if (page == 'improve') {
    router.push({
      path: 'evaImprove',
      query: {
        currentIdentity: 'member'
      }
    })
  } else if (page == 'course') {
    router.push({
      path: 'training',
      query: {
        currentIdentity: 'meinfo'
      }
    })
  } else if (page == 'customized') {
    router.push({
      path: 'esgReg',
      query: {
        currentIdentity: 'meinfo'
      }
    })
  } else if (page == 'report') {
    router.push({
      path: 'report',
      query: {
        currentIdentity: 'meinfo'
      }
    })
  } else if (page == 'user') {
    router.push({
      path: 'userInfo',
      query: {
        currentIdentity: 'member'
      }
    })
  } else if (page == 'company') {
    router.push({
      path: 'companyInfo',
      query: {
        currentIdentity: 'member'
      }
    })
  } else if (page == 'loginout') {
    store.logout()
    router.push('/login')
    emit('updateIdentity', 'login')
  } else if (page == 'changePhone') {
    router.push({
      path: 'changePhone',
      query: {
        currentIdentity: 'member'
      }
    })
  } else {
    router.push(page)
  }
};

// 点击搜索结果项
const handleSearchItemClick = (item) => {
  // 检查是否需要登录 - 只显示isLogin为true的项，所以直接调用goToNav
  if (item.isLogin) {
    goToNav(item.path)
  }

  // 清空搜索状态
  searchValue.value = ''
  isSearchFocused.value = false
  searchStatus.value = ''
}

// 搜索处理
const handleSearchInput = () => {
  const keyword = searchValue.value.trim()
  if (keyword) {
    searchStatus.value = 'loading'
    doSearch(keyword)
  } else {
    searchStatus.value = ''
    searchResults.value = []
  }
}

// 实际搜索函数
const doSearch = debounce(async (keyword) => {
  try {

    // 取消之前的请求
    if (abortController) {
      abortController.abort()
    }

    // 创建新的AbortController
    abortController = new AbortController()

    const res = await Api.onSearch({
      query: keyword
    }, {
      signal: abortController.signal
    })

    if (res.code === 200) {
      // 解析返回的数据
      let data = []
      try {
        // 处理可能的字符串格式数据
        data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
        // 过滤掉isLogin为false的项
        data = data.filter(item => item.isLogin)
      } catch (e) {

        data = []
      }

      searchResults.value = data
      searchStatus.value = data.length > 0 ? 'success' : 'empty'
    } else {
      searchStatus.value = 'error'
      searchResults.value = []
    }
  } catch (error) {
    // 如果是取消请求的错误，不显示错误状态
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
      return
    }

    searchStatus.value = 'error'
    searchResults.value = []
  }
}, 500)

// 点击页面其他地方关闭搜索结果
const handleDocumentClick = (e) => {
  const searchWrapper = document.querySelector('.search-wrapper')
  if (searchWrapper && !searchWrapper.contains(e.target)) {
    isSearchFocused.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleDocumentClick)
})

onUnmounted(() => {
  document.removeEventListener('click', handleDocumentClick)

  // 组件卸载时取消所有 pending 的请求
  if (abortController) {
    abortController.abort()
  }
})

const a = () => {
  // Empty function as in original
};

</script>

<style scoped lang="scss">
.mainBarMember {
  min-width: 1100px;
  max-width: 1980px;
  z-index: 10;
  width: 100%;
  height: 112px;
  box-shadow: 0px 4px 10.1px 0px rgba(0, 0, 0, 0.10);
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top: 0;
  box-shadow: 0px 4px 10.1px 0px rgba(0, 0, 0, 0.1);
  background-color: rgba(0, 0, 0, 0.5);
}

.bc1 {
  background-color: #ffffff;
}

.bc2 {
  background-color: rgba(0, 0, 0, 0.5);
}

.mainBarMember .logo {
  width: max(min(7vw, 140px), 112px);
  height: max(min(5.01vw, 102px), 81.6px);
  margin-left: max(min(2.4vw, 48px), 30px);
}

.mainBarMember .leftBox {
  display: flex;
  flex-direction: row;
  margin-right: max(min(3vw, 60px), 35px);
  height: 100%;
  justify-content: space-around;
  align-items: center;
}

// 搜索包装器
.search-wrapper {
  position: relative;

  .searchBox {
    width: max(min(18.5vw, 370px), 200px);
    height: 40px;
    border-radius: 4px;
    background-color: #F0F2F5;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: rgba(16, 38, 59, 0.60);
    font-size: 15px;
    font-weight: 400;

    :deep(.ant-input) {
      background-color: transparent;
    }

    img {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  // 搜索结果下拉框
  .search-results {
    position: absolute;
    top: 45px;
    left: 0;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    max-height: 300px;
    overflow-y: auto;

    .search-loading,
    .search-error,
    .search-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      color: rgba(16, 38, 59, 0.60);
    }

    .search-items {
      .search-item {
        padding: 0 16px;
        line-height: 3;
        cursor: pointer;
        color: #26734C;
        font-size: 14px;
        border-bottom: 1px solid rgba(38, 115, 76, 0.1);
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background-color: rgba(38, 115, 76, 0.05);
        }

        .login-required {
          font-size: 12px;
          color: #ff4d4f;
          margin-left: 8px;
        }
      }
    }
  }
}

.mainBarMember .leftBox .nav1 {
  font-size: 16px;
  color: #26734C;
  border-bottom: 2px solid rgba(0, 0, 0, 0);
  padding-bottom: 4px;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  line-height: 1.2;
}

.mainBarMember .leftBox .nav1:hover {
  color: #1F4733;
  border-bottom: 2px solid #1F4733;
}

.mainBarMember .leftBox .mgl {
  margin-left: max(min(3.5vw, 70px), 30px);
}

.mainBarMember .leftBox .nav2 {
  position: relative;
  font-size: 16px;
  color: #1F4733;
  border-bottom: 2px solid #1F4733;
  padding-bottom: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  line-height: 1.2;
}

.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}

.mainBarMember .leftBox .toast {
  position: absolute;
  width: 187px;
  top: 40px;
  z-index: 20;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 2px 5px 8px 0 rgba(82, 90, 102, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.mainBarMember .leftBox .w1 {
  width: 120px;
  left: 38px;
}

.mainBarMember .leftBox .toast .content {
  color: #26734C;
  font-size: 14px;
  font-weight: 400;
  margin-left: 10px;
  cursor: pointer;
  height: 42px;
  display: flex;
  align-items: center;
}

.mainBarMember .leftBox .toast .content:hover {
  color: #1F4733;
}

.mainBarMember .leftBox .icon {
  width: 24px;
  height: 24px;
  margin-right: 16px;
}

.mainBarMember .leftBox .arrow {
  width: 12px;
  height: 12px;
  margin-left: 10px;
}

.block {
  flex: 1;
}

:deep(.ant-input) {
  background-color: transparent;
}

.loginBox {
  position: absolute;
  right: max(min(3vw, 60px), 35px);
  bottom: 5px;
  width: 110px;
  height: 30px;
  border-radius: 30px;
  background-color: #d2efdd;
  color: #199145;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
}
</style>